import { ReactNode } from 'react';
import { LocalizedTypography } from '@mews-commander/ui';
import { Card, CardProps, Stack, Typography } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { SimpleAmount } from '@mews-commander/data-access';
import { LocalizedCurrencyValue } from '@mews/framework';

interface PaymentRefundDetailsCardProps extends Pick<CardProps, 'outline' | 'variant'> {
    titleTextKey: Mews.TextKey;
    conversionRateTextKey: Mews.TextKey;
    conversionRate: ReactNode;
    chargeCurrencyAmount: SimpleAmount;
    propertyCurrencyAmount: SimpleAmount;
}

export const PaymentRefundDetailsWithFXCard = ({
    outline,
    variant,
    titleTextKey,
    conversionRateTextKey,
    conversionRate,
    chargeCurrencyAmount,
    propertyCurrencyAmount,
}: PaymentRefundDetailsCardProps) => (
    <Card padding="200" outline={outline} variant={variant}>
        <Stack vertical spacing="50">
            <LocalizedTypography textStyle="bodySmallStrong" variant="primary" textKey={titleTextKey} as="div" />
            <LocalizedTypography
                textStyle="bodySmall"
                variant="secondary"
                textKey={TextKey.PaymentRefundInChargedCurrency}
                as="div"
            />
            <Typography textStyle="bodyMedium" variant="primary" as="div">
                <LocalizedCurrencyValue
                    value={{ value: chargeCurrencyAmount.value, currency: chargeCurrencyAmount.currencyCode }}
                    options={{
                        precision: 2,
                    }}
                />
            </Typography>
            <LocalizedTypography
                textStyle="bodySmall"
                variant="secondary"
                textKey={TextKey.PaymentRefundInPropertyCurrency}
                as="div"
            />
            <Typography textStyle="bodyMedium" variant="primary" as="div">
                <LocalizedCurrencyValue
                    value={{ value: propertyCurrencyAmount.value, currency: propertyCurrencyAmount.currencyCode }}
                    options={{
                        precision: 2,
                    }}
                />
            </Typography>
            <LocalizedTypography textStyle="bodySmall" variant="secondary" textKey={conversionRateTextKey} as="div" />
            <Typography textStyle="bodyMedium" variant="primary" as="div">
                {conversionRate}
            </Typography>
        </Stack>
    </Card>
);
